/*
    © 2022 KondaSoft.com
    https://www.kondasoft.com
*/

/*
    Main 'Add to cart' (ATC) form
*/
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('.btn-atc')

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    form.classList.add('loading')

    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

    form.classList.remove('loading')
    btn.innerHTML = window.theme.product.addedToCart

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textAddToCart
    }, 2000)

    window.refreshCartContents(response)

    bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
}

window.toggleSelection = (input, selector) => {
    $(`.product-option.${selector}`).next('.option-value-name').html(input.querySelector('input').value);
    $(`.product-option.${selector} .indicator`).removeClass('selected')
    $(`.product-option.${selector}.selected`).removeClass('selected')
    
    input.classList.add('selected')
    input.querySelector('.indicator').classList.add("selected")
}

window.setColorProperty = (color, element) => {
    document.getElementById('color-choice').value = color;
    window.exceededVariantGoldColor = color;

    $(`.product-option.material-gold-color`).next('.option-value-name').html(color);
    $(`.product-option.material-gold-color .indicator`).removeClass('selected')
    $(`.product-option.material-gold-color.selected`).removeClass('selected');
  
    element.classList.add('selected');
    element.querySelector('.indicator').classList.add("selected");
}

/*
    Product options selector - Listen for change events
    Works only in the product page
*/
window.onChangeProductOption = async (input) => {
    const selectedOptions = []

    let optionsCount = 0;
    let includeAllHandle = false;
    const productOptionColor = $('.product-option.color')
    const productOptionSize = $('.product-option.size')
    const productOptionGoldColor = $('.product-option.gold-color')

    const productOptionStyle = $('.product-option.style')

    const productOptionColorLeft = $('.product-option.color-left')
    const productOptionColorRight = $('.product-option.color-right')

    if (productOptionColor[0]) optionsCount++;
    if (productOptionSize[0]) optionsCount++;
    if (productOptionGoldColor[0]) optionsCount++;
    if (productOptionStyle[0]) optionsCount++;
    if (productOptionColorLeft[0]) optionsCount++;
    if (productOptionColorRight[0]) optionsCount++;

    if (optionsCount > 1) {
      if ($(input).hasClass('color')) {
        toggleSelection(input, 'color')
      }
  
      if ($(input).hasClass('size')) {
        toggleSelection(input, 'size')
      }
  
      if ($(input).hasClass('style')) {
        toggleSelection(input, 'style')
      }
        
      if ($(input).hasClass('gold-color')) {
        toggleSelection(input, 'gold-color')
      }
        
      if ($(input).hasClass('color-left')) {
        toggleSelection(input, 'color-left')
      }
        
      if ($(input).hasClass('color-right')) {
        toggleSelection(input, 'color-right')
      }

      const selectedColor = $('.product-option.color.selected input')[0]
      const selectedSize = $('.product-option.size.selected input')[0]
      const selectedGoldColor = $('.product-option.gold-color.selected input')[0]

      const selectedStyle = $('.product-option.style.selected input')[0]
      
      const selectedColorLeft = $('.product-option.color-left.selected input')[0]
      const selectedColorRight = $('.product-option.color-right.selected input')[0]

      // Order matters in this part
      if (selectedColor)
        selectedOptions.push(selectedColor.value)
      
      if (selectedSize)
        selectedOptions.push(selectedSize.value)

      if (selectedStyle) 
        selectedOptions.push(selectedStyle.value)
      
      if (selectedGoldColor)
        selectedOptions.push(selectedGoldColor.value)
      
      if (selectedColorLeft) {
        includeAllHandle = true;
        selectedOptions.push(selectedColorLeft.value)
      }
      
      if (selectedColorRight) {
        includeAllHandle = true;
        selectedOptions.push(selectedColorRight.value)
      }
    } else {
      selectedOptions.push(input.querySelector('input').value)
      
      $('.option-value-name').html(input.querySelector('input').value)
      $('.indicator').removeClass('selected')
      input.querySelector('.indicator').classList.add("selected")
    }

    const selectedVariant = window.productVariants.find(variant =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    const selectedVariantHandle = selectedVariant.title.toLowerCase().replace(/\s/g, '-');

    if (includeAllHandle) {
      const mergedHandle = selectedVariantHandle.replace('-/-', '');

      if (mergedHandle.toLowerCase() == 'redred') {
        window.location.href = 'https://thegoldalbum.com/products/alliance-of-moms-bespoke-heart-pendant';
        return;
      }
      
      changeGallery(mergedHandle, false);
    } else {
      changeGallery(selectedVariantHandle, false);
    }

    let inventoryHash = document.querySelectorAll('[InventoryManagement]');

    if (inventoryHash) {
      Array.from(inventoryHash).forEach(
          (variant) => {
            if(variant.dataset.id == selectedVariant.id) {
              if (window.bespokeMessage) {
                $('.availability-notification').html(window.bespokeMessage);
              }
              else if(variant.dataset.available == 'true') {
                $('.availability-notification').html(window.availableMessage);
              } else {
                $('.availability-notification').html(window.outOfStockMessage);
              }
            }
          });
    }

    const btn = input.closest('form').querySelector('.btn-atc')

    if ($('.accordion').find(`.description-${selectedVariant.id}`).length) {
        $('.accordion').find('.description').addClass('d-none');
        $('.accordion').find(`.description-${selectedVariant.id}`).removeClass('d-none');
    }

    if (selectedVariant) {
        input.closest('form').querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            btn.disabled = false
            btn.innerHTML = window.theme.product.addToCart
        } else {
            btn.disabled = true
            btn.innerHTML = window.theme.product.soldOut
        }

        document.querySelector('#addToCart').innerHTML = `
            Add to cart - 
            <span class="product-price-final">
                ${Shopify.formatMoney(selectedVariant.price)}
            </span>
        `

        // if (selectedVariant.compare_at_price) {
        //     input.closest('#product-content').querySelector('.product-price').innerHTML = `
        //         <span class="product-price-compare text-muted me-3">
        //             <span class="visually-hidden">
        //                 ${window.theme.product.priceFrom} &nbsp;
        //             </span>
        //             <s>
        //                 ${Shopify.formatMoney(selectedVariant.compare_at_price)}
        //             </s>
        //         </span>
        //         <span class="product-price-final">
        //             <span class="visually-hidden">
        //                 ${window.theme.product.priceSale} &nbsp;
        //             </span>
        //             ${Shopify.formatMoney(selectedVariant.price)}
        //         </span>
        //     `
        // } else {
        //     input.closest('#product-content').querySelector('.product-price').innerHTML = `
        //         <span class="product-price-final">
        //             ${Shopify.formatMoney(selectedVariant.price)}
        //         </span>
        //     `
        // }
        // if (selectedVariant.available && selectedVariant.compare_at_price) {
        //     input.closest('#product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
        //         <span class="price-badge-sale badge">
        //             ${window.theme.product.save}: ${Math.round((1 - (selectedVariant.price / selectedVariant.compare_at_price)) * 100)}%
        //         </span>    
        //     `)
        // } else if (!selectedVariant.available) {
        //     input.closest('#product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
        //         <span class="price-badge-sold-out badge">
        //             ${window.theme.product.soldOut}
        //         </span>
        //     `)
        // }

        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)

        const customEvent = new CustomEvent('variantChange.ks.product', {
            detail: selectedVariant
        })
        window.dispatchEvent(customEvent)
    } else {
        btn.disabled = true
        btn.innerHTML = window.theme.product.unavailable
    }
}

const changeGallery = (variantHandle, showAll) => {
    // TODO: Explore more options for gallery
    // The first devs only made it available to colors...
    const oldHandle = variantHandle;
    if (!variantHandle) return;
  
    variantHandle = variantHandle.split('-/-')[0];
    console.log(`showing images for : ${oldHandle} (${variantHandle})`);
    if (!showAll) {
        $('#product-gallery-mobile').remove();
        $('.gallery-container').append('<div id="product-gallery-mobile" class="position-relative d-md-none"></div>');
    }
    var variantElements = $(`[data-variant="${variantHandle}"]`);
    variantElements.push($('[data-variant="all"]'))

    if(variantElements.length > 1) {
        if (!showAll) {
            $('.product-gallery-img').addClass('hide')
        }

        variantElements.each(function() {
            $(this).removeClass('hide');
            $(this).clone().appendTo( "#product-gallery-mobile" );
        });

        initProductGalleryMobile(showAll);
        
    } else {
        const carousel = $('#product-gallery-mobile');
        if (carousel) {
            const images = $('.product-gallery-img');
            images.each(function() {
                $(this).clone().appendTo( "#product-gallery-mobile" );
            });
            carousel.slick({
                dots: true
            })
        }
    }

    const hasSticker = document.querySelector('.sticker')

    if (hasSticker) {
        $(".slick-current").first().prepend("<img class='sticker' src='https://cdn.shopify.com/s/files/1/0842/6228/9706/files/sticker-exclusive.svg?v=1715788141' alt='exclusive'>");
    }
}


/*
    Product Gallery
*/

const initProductGalleryMobile = (showAll) => {
    
    const carousel = $('#product-gallery-mobile')
    if (carousel) {
        carousel.slick({
            dots: true
        })

        if (showAll) {
            console.log(carousel)
            const imgHeight = carousel.height();
            console.log(imgHeight)
            $('#product-gallery-mobile').css('min-height' , imgHeight)
        }
    }
}

const initProductGallery = () => {
    const currentVariantHandle = $('input[name="current-variant-handle"]').val();

    const includeAllHandle = $('.product-dual-container')[0];
    if (includeAllHandle) {
      const mergedHandle = currentVariantHandle.replace('-/-','');
      changeGallery(mergedHandle, true);
    } else {
      changeGallery(currentVariantHandle, true);
    }
}


initProductGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#product-gallery')) {
        initProductGallery()
    }
})

/*
    'Buy it now' button
*/
window.onClickBuyBtn = (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const form = btn.closest('form')
    const variantId = form.querySelector('[name="id"]').value
    const qty = Number(form.querySelector('input[name="quantity"]').value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
}
